
import { Component, Vue, Watch } from "vue-property-decorator";
import api from "../../network/api";
import { AxiosResponse } from "axios";
import { Getter } from "vuex-class";
@Component
export default class NewsTicker extends Vue {
  news: any = [];
  @Getter("eventId") private eventId!: number;

  @Watch("eventId")
  createSubscription() {
    this.loadNews();
    this.$socket.client.on(
      "evenue_database_NewNews." + this.eventId,
      (payload: any) => {
        let index: any = -1;
        this.news.forEach(function(obj: any, id: any) {
          if (obj.id == payload.event.id) {
            index = id;
          }
        });
        if (index == -1 && payload.event.enabled) {
          this.news.push(payload.event);
        } else {
          if (payload.event.enabled) {
            // insert
            this.news.splice(index, 1, payload.event);
          } else {
            // remove
            this.news.splice(index, 1);
          }
        }
      }
    );

    this.$socket.client.on(
      "evenue_database_DeleteNews." + this.eventId,
      (payload: any) => {
        let index: any = -1;
        this.news.forEach(function(obj: any, id: any) {
          if (obj.id == payload.event.id) {
            index = id;
          }
        });
        if (index >= 0) {
          this.news.splice(index, 1);
        }
      }
    );
  }
  loadNews() {
    api
      .get("news", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
      .then((response: AxiosResponse) => {
        this.news = response.data.news;
      });
  }
  direction() {
    if (this.$i18n.locale == "en") {
      return "left";
    } else {
      return "right";
    }
  }
  beforeDestroy() {
    this.$socket.client.off(
      "evenue_database_NewNews." + this.eventId
    );
    this.$socket.client.off(
      "evenue_database_DeleteNews." + this.eventId
    );
  }
}
